/**
 * Angular Imports
 */
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
/**
 * Interface Imports
 */
import { Profile, Speciality } from '../../interface/userprofile/userprofile';
import { UserProfile } from './../../interface/editors-choice/editors-choice.model';
/**
 * rxjs Imports
 */
import { Subscription } from 'rxjs';
/**
 * Service Imports
 */
import { MasterserviceService } from '../../dataservices/master-service/masterservice.service';
import { EventMsgService } from '../../dataservices/master-service/event-msg.service';
import { FunCollectionService } from '../../common/common-functions/fun-collection.service';
import { DataStorageService } from '../../dataservices/data-storage.service';
/**
 * Constant imports
 */
import { EDITORS_DETAIL, SCREEN_NAME, PRODUCT_TYPE_CONSTANT, CALLING_FROM, PRODUCT_TYPE_CONSTANT_NAME, CTA_TYPE, ACTION_TYPE, ACTION_ON } from '../../constants/app.constants';
import { EVENT_NAME } from './../../analytics-event/analytics.constant';
/**
 * sdk imports
 */
import { Analytics } from 'analytics2.0';

/**
 * component for Editor-choice profile .
 */
@Component({
  selector: 'app-editor-choice-detail-profile',
  templateUrl: './editor-choice-detail-profile.component.html',
  styleUrls: ['./editor-choice-detail-profile.component.scss']
})
export class EditorChoiceDetailProfileComponent implements OnInit, OnDestroy {
  /**
   * input for profile_left_pic_image
   */
  @Input() profile_left_pic_image: Profile;
  /**
   * input for userProfileData
   */
  @Input() userProfileData: UserProfile;
  /**
   * input for profileInfo
   */
  @Input() profileInfo: Profile;
  /**
   * input for userSpeciality
   */
  @Input() userSpeciality: Speciality[];
  /**
   * input for designation
   */
  @Input() designation: string;
  /**
   * input for userProfile
   */
  @Input() userProfile: Profile;
  /**
   * input for activeModule
   */
  @Input() activeModule: string;
  /**
   * EC ID.
   */
  @Input() ecPostId: number;
  /**
   * property for profile
   */
  public profile: UserProfile;
  /**
   * Constant for string editors_detail.
   */
  public editorChoice = EDITORS_DETAIL.EC_DETAIL;
  /**
   * variable for unsubscribing
   */
  public allSubscriptions: Subscription = new Subscription();

  /**
   * Used to hold calling from value.
   */
  public callingFrom = CALLING_FROM;

  /**
   * Screen name.
   */
  public screenName = SCREEN_NAME.EC_DETAIL;
  /**
   * product constant
   */
  public productTypeConstant = PRODUCT_TYPE_CONSTANT.EDITORS_CHOICE;

  /**
   * Necessary instance.
   */
  constructor(
    public dss: DataStorageService,
    public ems: EventMsgService,
    public masterService: MasterserviceService,
    public funCollectionService: FunCollectionService,
    private analyticSdk: Analytics
  ) {
    const editorChoiceDetailSubs = this.masterService.profile_api_data.subscribe(data => {
      this.userProfileData = data;
    }
    );
    this.allSubscriptions.add(editorChoiceDetailSubs);
  }

  ngOnInit(): void {
  }
  /**
   * method for navigating to ec-profile agter clicking.
   */
  navigateToProfile(): void {
    if (this.activeModule != 'profile') {
      this.funCollectionService.navigateToUserProfie(this.userProfile.custom_id);
    }
  }
  /**
   * profile pic clicked
   */
  profilePicClicked(): void {
    this.analyticSdk.analyticService.CLICK(PRODUCT_TYPE_CONSTANT_NAME.INSIGHT_COLLECTOR, this.ecPostId, this.screenName, CTA_TYPE.ICON, ACTION_TYPE.CLICK, ACTION_ON.PROFILE_ICON, null);
  }
  /**
   * Unsubscribe subscribe data.
   */
  ngOnDestroy(): void {
    if (this.allSubscriptions) {
      this.allSubscriptions.unsubscribe();
    }
  }
}

